<template>
    <div id="content" class="testPaperContent">
        <div class="sortBox">
            <!-- <div :class="isNewClick?'newBg sortNew sortFlex':'sortNew sortFlex'" @click="Sort(1)">最新
                <img src="/static/images/sortUped.png" alt=""  v-if="isNewClick">
                <img src="/static/images/sortUp.png" alt="" v-else>
            </div> -->

            <!-- <div :class="isDownClick?'downBg sortNew sortFlex':'sortNew sortFlex'" @click="Sort(3)">下载量
                <img src="/static/images/sortUped.png" alt="" v-if="isDownClick">
                <img src="/static/images/sortUp.png" alt="" v-else>
            </div> -->
        </div>
        <!-- <Tabs type="card" animated :value="tabType" @on-click="choseTab" >
            <TabPane label="学堂试卷" name="1"></TabPane>
            <TabPane label="全国试卷" name="2"></TabPane>
            <TabPane label="区域试卷" name="3"></TabPane>
            <TabPane label="校本试卷" name="4"></TabPane>
            <TabPane label="我的试卷" name="5"  v-if="userType == 'teacher'"></TabPane>
        </Tabs> -->
        <div class="areaTabBox">
            <div :class="tab1?'tabItem xuet tabActive':'tabItem xuet'" @click="choseTab(1)">学堂试卷</div>
            <div :class="tab2?'tabItem tabActive':'tabItem'" @click="choseTab(2)">全国试卷</div>
            <div :class="tab3?'tabItem tabActive':'tabItem'" @click="choseTab(3)">区域试卷</div>
            <div :class="tab4?'tabItem tabActive':'tabItem'" @click="choseTab(4)">校本试卷</div>
            <div :class="tab5?'tabItem tabActive':'tabItem'" @click="choseTab(5)">我的试卷</div>
        </div>
        <div class="uploadBox">
            <div class="material">共{{pageCount}}份试卷</div>
            <div class="upload" @click="upLoad" v-show="isUpLoadBtn" v-if="userType == 'teacher'">
                <img src="/static/images/upload.png" alt="">上传资源
            </div>
        </div>
        <!-- 数据为空时显示 组件 -->
        <empty v-if="isEmpty"></empty>
        <List v-if="!isEmpty">

            <div class="listItem"  v-for="(item,index) in dataInfo" :key="index">
                <div class="avatar">
                    <img src="/static/images/wordImg.png"  alt="">
                </div>
                <div class="description">
                    <!-- <div class="itemTitle" @click="view(item.handoutOriginalDocPath)" >{{item.handoutTitle}}</div> -->
                    <div class="itemTitle" v-if="tabType == 1" @click="view(item,3,3,1)" >{{item.handoutTitle}}</div>
                    <!-- <div class="itemTitle" v-if="tabType == 1"  >{{item.handoutTitle}}</div> -->
                    <div class="itemTitle" v-else @click="view(item,3,3,2)" >{{item.handoutTitle}}</div>
                    <!-- <div class="itemPlace">
                        <div class="itemAuthor">作者：{{}}</div>
                        <div class="itemSchool">所属院校：清华大学</div>
                    </div> -->
                    <div class="itemNumber" v-if="tabType == 1" style="margin-top: 0;">
                        <div class="itemTime">&nbsp;</div>
                        <!-- <div class="itemViews"><img class="viewsImg" src="/static/images/views.png" alt="">{{item.handoutDownloadCount}}</div> -->
                        <!-- <div class="itemViews"><img src="/static/images/downLoad.png" alt="">{{item.handoutDownloadCount}}</div> -->
                    </div>
                    <div class="itemNumber" v-else-if="tabType == 5" style="margin-top: 0;">
                        <div class="itemTime" v-if="item.creatorSchoolName">所属院校：{{item.creatorSchoolName}}</div>
                        <div class="itemTime" v-else>&nbsp;</div>
                        <!-- <div class="itemViews"><img class="viewsImg" src="/static/images/views.png" alt="">{{item.handoutDownloadCount}}</div> -->
                        <!-- <div class="itemViews"><img src="/static/images/downLoad.png" alt="">{{item.handoutDownloadCount}}</div> -->
                    </div>
                    <div class="itemNumber" v-else style="margin-top: 0;">
                        <div class="itemTime" v-if="!item.creatorSchoolName && !item.creatorName">&nbsp;</div>
                        <div class="itemTime" v-else>作者：{{item.creatorName ?item.creatorName:''}} <span style="margin-left: 20px;">所属院校：{{item.creatorSchoolName?item.creatorSchoolName:''}}</span></div>
                        <!-- <div class="itemViews"><img class="viewsImg" src="/static/images/views.png" alt="">{{item.handoutDownloadCount}}</div> -->
                        <!-- <div class="itemViews"><img src="/static/images/downLoad.png" alt="">{{item.handoutDownloadCount}}</div> -->
                    </div>
                    <div class="itemNumber" style="margin-top: 0;">
                        <div class="itemTime">上传时间：{{item.handoutCreateTime}}</div>
                        <!-- <div class="itemViews"><img class="viewsImg" src="/static/images/views.png" alt="">{{item.handoutDownloadCount}}</div> -->
                        <!-- <div class="itemViews"><img src="/static/images/downLoad.png" alt="">{{item.handoutDownloadCount}}</div> -->
                    </div>
                </div>
                <div class="itemDownLoad" v-show="isShowDownloadBtn">
                    <Button type="info" shape="circle" ghost class="downLoadBtn" v-if="tabType == 1"  @click="download(item,3,2,1)" >下载</Button>
                    <Button type="info" shape="circle" ghost class="downLoadBtn" v-else  @click="download(item,3,2,2)" >下载</Button>
                    <!-- <Button type="info" ghost class="downLoadBtn" @click="palyVideo(item.videoId)" v-else>查看</Button> -->
                </div>
            </div>
            <div class="page" v-show="pageCount > 6">
                <Page :total="pageCount" :page-size='6' @on-change="changePage" :current.sync="currentPage"/>
            </div>
        </List>
        <message v-show="isShowMessage" :msg="msg" @isShowMsg="isShowMsg" :isShowMessage="isShowMessage"></message>
    </div>
</template>
<script>
import  api from '../../utils/api.js'
import bus from '../../assets/eventBus/enentBus.js'
import empty from '../Empty/Empty.vue'
import message from '../Message/Message.vue'
import cookie from '../../assets/getCookie.js'
import statistic from '../../assets/statistics.js'
export default {
    name:'testPaperVIew',
    data(){
        return{
            urlHttp:'/testIp',
            url: '/axt-examination/daily_practice/pageHandoutList/?orderBys%5B0%5D.field=createTime&orderBys%5B0%5D.direction=desc',
            dataInfo:[],
            gradeId:null,
            subjectId:null,
            versionId:null,
            typeId:null,
            tabType:'1',
            pageNum:1,
            pageCount:0,
            isEmpty:false,
            shareWebsiteId:null,            //区域id
            shareSchoolId:null,             //学校id
            shareNetId:1,                   //全国 id
            handoutTeacherId:null,          //教师id
            pageOne:1,                      //学堂资源 页码
            pageTwo:1,                      //全国资源 页码
            pageThree:1,                    //区域资源 页码
            pageFour:1,                     //校本资源 页码
            pageFive:1,                     //我的资源 页码
            isShowMessage:false,
            isShowDownloadBtn:false,                                     //是否显示下载按钮  登录 之后 显示
            isUpLoadBtn:false,
            msg:null,
            field:null,                      //排序字段
            isDownClick:false,
            isNewClick:false,
            userType:null,                               //用户角色
            gradeIdLong:null,
            subjectIdLong:null,
            tab1:true,
            tab2:false,
            tab3:false,
            tab4:false,
            tab5:false,
            currentPage:1,                              //默认第一页

        }
    },
    created(){
        const that = this;
        bus.$off('testGradeId');
        bus.$on('testGradeId',function(msg){
            that.currentPage = 1;
            that.gradeId = msg;
            that.getData(1,that.gradeId,that.subjectIdLong,that.versionId,that.typeId);
            // that.choseTab(that.tabType)
        });
        // bus.$off('testGradeIdLong')
        // bus.$on('testGradeIdLong',function(msg){
        //     that.currentPage = 1;
        //     that.gradeIdLong = msg;
        //     that.getData(1,that.gradeIdLong,that.subjectIdLong,that.versionId,that.typeId);
        // })
        bus.$off('testSubjectId');
        bus.$on('testSubjectId',function(msg){
            that.currentPage = 1;
            that.subjectId = msg;
        })
        bus.$off('testSubjectIdLong')
        bus.$on('testSubjectIdLong',function(msg){
            that.currentPage = 1;
            that.subjectIdLong = msg;
            that.getData(1,that.gradeId,msg,that.versionId,that.typeId);
        })
        bus.$off('testPaperId');
        bus.$on('testPaperId',function(msg){
            that.currentPage = 1;
            that.typeId = msg;
            that.getData(1,that.gradeId,that.subjectIdLong,that.versionId,msg);
        })
        bus.$off('versionId');
        bus.$on('versionId',function(msg){
            that.currentPage = 1;
            that.versionId = msg;
            that.getData(1,that.gradeId,that.subjectIdLong,msg,that.typeId);
        })
    },
    mounted(){
        const that = this;
        // if(this.tabType == 1) {
        //     this.url =  '/axt-examination/daily_practice/pageHandoutList/?orderBys%5B0%5D.field=createTime&orderBys%5B0%5D.direction=desc'
        // }else{
        //     this.url =  '/axt-data/dataHandout/pageDataHandout/?orderBys%5B0%5D.field=createTime&orderBys%5B0%5D.direction=desc'
        // }

        this.websiteId = localStorage.getItem('websiteId');
        const cookie_token = cookie.getCookie('AXY_'+ this.websiteId +'_access_token')
        if(cookie_token){
            if(cookie_token != 'null'){
                this.isShowDownloadBtn = true;
                this.shareSchoolId = localStorage.getItem('schoolId');
                this.handoutTeacherId = localStorage.getItem('userId');
                this.userType = localStorage.getItem('userType');
            }
        }else{
            this.isShowDownloadBtn = false;
        }
        setTimeout(function(){
          that.getData(1,that.gradeIdLong,that.subjectIdLong,that.versionId,that.typeId);
        },300)

    },
    methods:{
        getData(pageNo,gradeId,subjectId,versionId,typeId,dataId){
            const that = this;
            if(this.tabType == 1) {
                this.url =  '/axt-examination/daily_practice/pageHandoutList'
            }else{
                this.url =  '/axt-data/dataHandout/pageDataHandout/?orderBys%5B0%5D.field=handout_create_time&orderBys%5B0%5D.direction=desc'
            }
            if(this.tabType == 1){
                var params = {
                    pageSize:6,
                    pageNo:pageNo,
                    handoutBaseGradeId:gradeId,
                    handoutSubjectId:subjectId,
                    versionId:versionId,
                    handoutPaperType:typeId,
                    orderBys:[
                        {
                            field:'handout_create_time',
                            direction:'desc'
                        }
                    ],
                    websiteId:this.websiteId
                };
                this.httpPost(this.url,params)
            }

            if(this.tabType == 2){
                var params = {
                    pageSize:6,
                    pageNo:pageNo,
                    handoutGradeId:gradeId,
                    handoutSubjectId:subjectId,
                    handoutVersionId:versionId,
                    handoutPaperType:typeId,
                    shareNetId : 1,             //全国资源
                    // orderBys:[
                    //     {
                    //         field:this.field,
                    //         direction:'desc'
                    //     }
                    // ]
                };
               // params = this.$qs.stringify(params)
                this.httpGet(this.url,params)
            }
            if(this.tabType == 3){
                var params = {
                    pageSize:6,
                    pageNo:pageNo,
                    handoutGradeId:gradeId,
                    handoutSubjectId:subjectId,
                    handoutVersionId:versionId,
                    handoutPaperType:typeId,
                    shareWebsiteId : localStorage.getItem('websiteId'),         //区域id
                };
                //params = this.$qs.stringify(params)
                this.httpGet(this.url,params)
            }
            if(this.tabType == 4){
                var params = {
                    pageSize:6,
                    pageNo:pageNo,
                    handoutGradeId:gradeId,
                    handoutSubjectId:subjectId,
                    handoutVersionId:versionId,
                    handoutPaperType:typeId,
                    shareSchoolId : localStorage.getItem('schoolId'),        //学校id
                    // orderBys:[
                    //     {
                    //         field:this.field,
                    //         direction:'desc'
                    //     }
                    // ]
                };
                //params = this.$qs.stringify(params)
                this.httpGet(this.url,params)
            }
            if(this.tabType == 5){
                var params = {
                    pageSize:6,
                    pageNo:pageNo,
                    handoutGradeId:gradeId,
                    handoutSubjectId:subjectId,
                    handoutVersionId:versionId,
                    handoutPaperType:typeId,
                    handoutTeacherId : localStorage.getItem('userId'),       //教师id
                    // orderBys:[
                    //     {
                    //         field:this.field,
                    //         direction:'desc'
                    //     }
                    // ]
                };
                //params = this.$qs.stringify(params)
                this.httpGet(this.url,params)
            }

        },
        httpPost(url,params){
            const that = this;
            api.postFormAPI(url,params).then(res => {
                console.log('试卷',res.data)
                if(res.data.success){
                    if(res.data.data.total == 0 || res.data.data == null){
                       that.isEmpty = true;
                       that.pageCount = 0;
                    }else{
                        const data = res.data.data;
                        that.pageCount = data.total;
                        // if(data.total == 0)  that.isEmpty = true;
                        that.dataInfo = data.rows;
                        that.isEmpty = false;
                    }
                }else{
                    // that.$Message.error(res.data.message);
                }

            })
        },
        httpGet(url,params){
            const that = this;
            api.getListAPI(url,params).then(res => {
                if(res.data.success){
                    if(res.data.data.total == 0 || res.data.data == null){
                       that.isEmpty = true;
                       that.pageCount = 0;
                    }else{
                        const data = res.data.data;
                        that.pageCount = data.total;
                        // if(data.total == 0)  that.isEmpty = true;
                        that.dataInfo = data.rows;
                        that.isEmpty = false;
                    }

                }else{
                    // that.$Message.error(res.data.message);
                }
            })
        },
        //切换tab
        choseTab(name){
           this.tabType = name;
           this.currentPage = 1;
           this.pageCount = 0;
           this.isEmpty = true
                        // if(data.total == 0)  that.isEmpty = true;
            this.dataInfo = [];
            if(name == 1){
                this.isUpLoadBtn = false;
                this.tab1 = true;
                this.tab2 = false;
                this.tab3 = false;
                this.tab4 = false;
                this.tab5 = false;
                this.getData(1,this.gradeIdLong,this.subjectIdLong,this.versionId,this.typeId,null);
            }
            if(name == 2){
                this.tab1 = false;
                this.tab2 = true;
                this.tab3 = false;
                this.tab4 = false;
                this.tab5 = false;
                this.isUpLoadBtn = false;
                this.getData(1,this.gradeIdLong,this.subjectIdLong,this.versionId,this.typeId,this.shareNetId);
            }
            if(name == 3){
                this.tab1 = false;
                this.tab2 = false;
                this.tab3 = true;
                this.tab4 = false;
                this.tab5 = false;
                this.isUpLoadBtn = false;
                this.getData(1,this.gradeIdLong,this.subjectIdLong,this.versionId,this.typeId,this.shareWebsiteId);
            }
            if(name == 4){
                if(this.shareSchoolId == null || this.shareSchoolId == undefined){
                    this.isShowMessage = true;
                    this.msg = ('您尚未登录');

                    // this.isEmpty = true;
                    // this.tabType = number;
                    return false
                }
                this.tab1 = false;
                this.tab2 = false;
                this.tab3 = false;
                this.tab4 = true;
                this.tab5 = false;
                this.isUpLoadBtn = false;
                this.getData(1,this.gradeIdLong,this.subjectIdLong,this.versionId,this.typeId,this.shareSchoolId);
            }
            if(name == 5){
                if(this.shareSchoolId == null || this.shareSchoolId == undefined){
                    this.isShowMessage = true;
                    this.msg = ('您尚未登录');
                    return false
                }
                this.tab1 = false;
                this.tab2 = false;
                this.tab3 = false;
                this.tab4 = false;
                this.tab5 = true;
                this.isUpLoadBtn = true;
                this.getData(1,this.gradeIdLong,this.subjectIdLong,this.versionId,this.typeId,this.handoutTeacherId);
            }

            },
            //切换页签
            changePage(page){
                if(this.tabType == 1){
                    this.pageOne = page;
                    this.getData(page,this.gradeIdLong,this.subjectIdLong,this.versionId,this.typeId);
                }
                if(this.tabType == 2){
                    this.pageTwo = page;
                    this.getData(page,this.gradeIdLong,this.subjectIdLong,this.versionId,this.typeId,this.shareNetId);
                }
                if(this.tabType == 3){
                    this.pageThree = page;
                    this.getData(page,this.gradeIdLong,this.subjectIdLong,this.versionId,this.typeId,this.shareWebsiteId);
                }
                if(this.tabType == 4){
                    if(this.shareSchoolId == null || this.shareSchoolId == undefined){
                        this.isShowMessage = true;
                        this.msg = ('您尚未登录');
                        this.tabType = number;
                        return false
                    }
                    this.pageFour = page;
                    this.getData(page,this.gradeIdLong,this.subjectIdLong,this.versionId,this.typeId,this.shareSchoolId);
                }
                if(this.tabType == 5){
                    if(this.shareSchoolId == null || this.shareSchoolId == undefined){
                        this.isShowMessage = true;
                        this.msg = ('您尚未登录');
                        this.tabType = number;
                        return false
                    }
                    this.pageFive = page;
                    this.getData(page,this.gradeIdLong,this.subjectIdLong,this.versionId,this.typeId,this.handoutTeacherId);
                }
            },
            upLoad(){
              this.$emit('isUpload',true)
              // bus.$emit('upLoadKnowledgeId',this.knowledgeId);
              // bus.$emit('upLoadStylelId',this.stylelId);
              // bus.$emit('upLoadGradeId',this.gradeId);
              // bus.$emit('upLoadSubjectId',this.subjectId);
              // bus.$emit('upLoadGradeIdLong',this.gradeIdLong);
              // bus.$emit('upLoadSubjectIdLong',this.subjectIdLong);
              // bus.$emit('upLoadVersionId',this.versionId);
              // bus.$emit('upLoadTestPaperId',this.typeId);
              const data = {
                  'upLoadKnowledgeId':this.knowledgeId,
                  'upLoadStylelId':this.stylelId,
                  'upLoadGradeId':this.gradeId,
                  'upLoadSubjectId':this.subjectId,
                  'upLoadGradeIdLong':this.gradeIdLong,
                  'upLoadSubjectIdLong':this.subjectIdLong,
                  'upLoadVersionId':this.versionId,
                  'upLoadTestPaperId':this.typeId
              }
              this.$emit('upLoadData',data)
            },
            view(item,access,operateType,source){
                // item.handoutOriginalDocPath,item.handoutId,item.handoutTitle 学堂资源 url,id,name
                // item.handoutQuestionFilePath,item.handoutId,item.handoutTitle
                const id = item.handoutId
                const name = item.handoutTitle
                let url = ''
                if(this.tabType == 1){
                   url = item.handoutOriginalDocPath || item.handoutQuestionFilePath || item.handoutAnalysisFilePath
                }else {
                   url = item.handoutQuestionFilePath
                }
                console.log(id,name,access,operateType,source)
                if(this.shareSchoolId == null || this.shareSchoolId == undefined){
                    this.isShowMessage = true;
                    this.msg = ('您尚未登录');
                    this.tabType = number;
                    return false
                }
                this.$emit("isplay",true)
                if (/\.ppt/gi.test(url) || /\.pptx/gi.test(url)
                    || /\.doc/gi.test(url) || /\.docx/gi.test(url)
                    || /\.xls/gi.test(url) || /\.xlsx/gi.test(url)
                    || /\.jpg/gi.test(url) || /\.png/gi.test(url)
                    || /\.pdf/gi.test(url)) {
                        const materialData = {
                            src:url,
                            id:id,
                            name:name,
                            soure:source,
                            access:access,
                            operateType:operateType,
                            type:1
                        }
                        console.log(materialData,'materialData111')
                        this.getMaterialUrl(materialData);
                }else {
                    if(this.tabType == 1){
                        var src = 'http://qcbantk.aixuetang.com/doc'+ url;
                    }else{
                      if(item.handoutPaperFrom == 0){
                        var src = 'http://qcban.aixuetang.com/res'+ url;
                      }else {
                        var src = 'http://qcbantk.aixuetang.com/doc'+ url;
                      }
                    }
                    const materialData = {
                            src:src,
                            id:id,
                            name:name,
                            soure:source,
                            access:access,
                            operateType:operateType,
                            type:1
                        }
                    bus.$emit('materialSrc',materialData)
                }
            },
            getMaterialUrl(src){
                const that = this;
                if(this.tabType == 1){
                    var url =  '/axt-resources/preview/selectTkDocumentPreviewUrl';
                }else{
                    var url =  '/axt-resources/preview/selectDocumentPreviewUrl';
                }

                const params = {
                    'downloadUrl':src.src
                }
                api.getListAPI(url,params).then(res => {
                    let datas = src;
                    datas.src = res.data.data;
                    bus.$emit('materialSrc',datas)
                })
            },
            download(item,access,operateType,source){
                const id = item.handoutId
                const name = item.handoutTitle
                let url = ''
                if(this.tabType == 1){
                   url = item.handoutOriginalDocPath || item.handoutQuestionFilePath || item.handoutAnalysisFilePath
                }else {
                   url = item.handoutQuestionFilePath
                }
                if(this.tabType == 1){
                    var downloadUrl = 'http://qcbantk.aixuetang.com/doc'+ url;
                }else{
                  if(item.handoutPaperFrom == 0){
                    var downloadUrl = 'http://qcban.aixuetang.com/res'+ url;
                  }else {
                    var downloadUrl = 'http://qcbantk.aixuetang.com/doc'+ url;
                  }

                }
                window.open(downloadUrl)
                statistic.testPater(id,name,access,operateType,source)
            },
            isShowMsg(msg){
                this.isShowMessage = false;
            },
            Sort(num){
                if(num == 1){
                    this.isNewClick = true;
                    this.isDownClick = false;
                    this.field = 'handout_create_time'
                }
                if(num == 2){
                    this.isViewClick = true;
                    this.field = 'countCheck'
                }
                if(num == 3){
                    this.isDownClick = true;
                    this.isNewClick = false;
                    this.field = 'handout_download_count'
                }
                this.choseTab(this.tabType)
            }
    },
    components:{empty,message}
}
</script>
<style lang="">
    .testPaperContent{
        margin-top: 26px!important;
        position: relative;
        border-top: solid 2px #3583FF;
         border-bottom: 1px solid #DADADA;
        border-right: 1px solid #DADADA;
        border-left: 1px solid #DADADA;
        min-height: 600px;
    }
    .sortBox{
        width:10%;
        height: 32px;
        position: absolute;
        top: 0;
        right: 0;
        display:flex;
        flex-direction: row;
        padding-right: 2%;
    }
    .sortFlex{
        flex: 1;
        justify-content: flex-end;
        text-align: right;
        font-size: 14px;
        line-height: 49px;
        z-index: 10;
    }
    .sortFlex:hover{
        cursor: pointer;
        color: #3583FF;
    }
    .sortFlex:hover .sortFlex img{
        background: #3583FF;
    }
    .sortFlex img{
        width:15px;
        height: 12px;
    }
     /* 上传 */
    .uploadBox{
        width:98%;
        overflow: hidden;
        padding-left: 2%;
        margin-top: 25px;
    }
    .uploadBox .material{
        float:left;
        font-size: 14px;
        color: #9A9A9A;
    }
    .uploadBox .upload{
        display: table-cell;
        vertical-align: middle;
        font-size: 14px;
        color: #F95F30;
        float: right;
    }
    .uploadBox .upload:hover{
        cursor: pointer;
    }
    .uploadBox .upload img{
        width:16px;
        height: 14px;
        display: inline-block;
    }
    .testPaperContent .listItem{
        width:96%;
        margin: 0 auto;
        height: 108px;
        box-sizing: content-box;
        padding-top: 32px;
        border-bottom: solid 1px #dadada;
        display: flex;
        flex-direction: row;
    }
    .avatar{
        flex:1;
        height: 100%;
        text-align: left;
    }
    .avatar img{
        width:65px;
        height:76px;
    }
    .description{
        flex:17;
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-left:10px;
    }
    .description .itemTitle{
        font-size: 16px;
        font-weight: 600;
        color: #34495E;
        line-height: 30px;
    }
    .description .itemTitle:hover{
        cursor: pointer;
        color:#3583FF
    }
    .description .itemPlace, .description .itemNumber{
        display: flex;
        flex-direction: row;
        font-size: 14px;
        font-weight: 500;
        color:#9a9a9a;
        line-height: 25px;
    }
    .testPaperContent .description .itemNumber {
      margin-top: 0;
    }
    .description .itemPlace .itemAuthor{
        padding-right: 35px;
    }
    .description .itemTime,.description .itemViews{
        padding-right: 35px;
        display: table-cell;
        vertical-align: middle;
    }
    .description .itemViews img{
        width:14px;
        height: 14px;
        margin-right: 5px;
    }
    .itemDownLoad{
        flex:1;
        line-height: 108px;
    }
    .newBg,.viewBg,.downBg{
        color:  #3683FF;
    }
    .testPaperContent .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab-active{
        color: #3683FF;
    }
    .testPaperContent .ivu-list-item-meta-content{
        text-align: left;
    }
    .testPaperContent .downLoadBtn{
        width:75px;
        height: 32px;
        border-radius: 16px;
        font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/testPaperView/testPaperView.vue